import type {RuleValidationErrors} from '../types';
import type {AdvancedRawRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateAdvancedRawRule = <
	T extends AdvancedRawRule = AdvancedRawRule,
>(
	rule: T,
): RuleValidationErrors | false => {
	if (typeof rule.elementValue1 !== 'string' || rule.elementValue1 === '') {
		return {
			elementValue1: createValidationObject(),
		};
	}
	return false;
};

export default validateAdvancedRawRule;
